import React from 'react';

const RevenuePanel = ({ revenueData, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="space-y-3">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount || 0);
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-gray-900">Revenue & Credits</h3>
        <span className="text-sm text-gray-500">
          {revenueData?.timestamp ? new Date(revenueData.timestamp).toLocaleTimeString() : 'Loading...'}
        </span>
      </div>

      <div className="space-y-6">
        {/* Revenue Stats */}
        <div>
          <div className="text-sm font-semibold text-gray-700 mb-3">Revenue</div>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-green-50 p-4 rounded-lg">
              <div className="text-2xl font-bold text-green-600">
                {formatCurrency(revenueData?.revenue_today)}
              </div>
              <div className="text-xs text-gray-600">Today</div>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg">
              <div className="text-2xl font-bold text-blue-600">
                {formatCurrency(revenueData?.revenue_month)}
              </div>
              <div className="text-xs text-gray-600">This Month</div>
            </div>
          </div>
        </div>

        {/* Credit Statistics */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Credit System</div>
          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div>
                <div className="text-sm text-gray-700">Credits Purchased</div>
                <div className="text-xs text-gray-500">Total credits bought</div>
              </div>
              <div className="text-2xl font-bold text-green-600">
                {revenueData?.credits_purchased?.toLocaleString() || 0}
              </div>
            </div>

            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div>
                <div className="text-sm text-gray-700">Credits Used</div>
                <div className="text-xs text-gray-500">Total credits consumed</div>
              </div>
              <div className="text-2xl font-bold text-orange-600">
                {revenueData?.credits_used?.toLocaleString() || 0}
              </div>
            </div>

            <div className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
              <div>
                <div className="text-sm text-gray-700">Utilization Rate</div>
                <div className="text-xs text-gray-500">Credits used / purchased</div>
              </div>
              <div className="text-2xl font-bold text-blue-600">
                {revenueData?.credits_purchased > 0 ?
                  ((revenueData.credits_used / revenueData.credits_purchased) * 100).toFixed(0) : 0}%
              </div>
            </div>
          </div>
        </div>

        {/* Subscription Stats */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Subscriptions</div>
          <div className="bg-gradient-to-r from-orange-50 to-orange-100 p-4 rounded-lg text-center">
            <div className="text-3xl font-bold text-orange-600">
              {revenueData?.active_subscriptions || 0}
            </div>
            <div className="text-sm text-gray-700 mt-1">Active Paid Subscriptions</div>
          </div>
        </div>

        {/* Payment Health */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Payment Health</div>
          <div className="flex items-center justify-center p-4 bg-green-50 rounded-lg">
            <div className="text-center">
              <div className="text-3xl font-bold text-green-600">
                {revenueData?.payment_success_rate?.toFixed(1) || '100.0'}%
              </div>
              <div className="text-xs text-gray-600 mt-1">Payment Success Rate</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenuePanel;

